const ACCOUNT_PASSWORD_DISABLE_STATE_KEY = 'onAccountPasswordDisableStateKey';

const singleSelectTypes = require('../digital-pay-single-select-type.constants');

class DigitalPayAccountController {
    constructor(settings, digitalPayPaymentDistributionService, digitalPayPaymentErrorDisplayService, digitalPayDisablePaymentStateService) {
        this.settings = settings;
        this.digitalPayPaymentDistributionService = digitalPayPaymentDistributionService;
        this.digitalPayPaymentErrorDisplayService = digitalPayPaymentErrorDisplayService;
        this.digitalPayDisablePaymentStateService = digitalPayDisablePaymentStateService;
    }

    getPayingAmount() {
        return this.digitalPayPaymentDistributionService.getPayment(this.onAccountPaymentAmountKey);
    }

    setPayingAmount() {
        this.digitalPayPaymentDistributionService.addPaymentInFull(this.onAccountPaymentAmountKey);
    }

    toggleSelected() {
        if (this.isSelected()) {
            this.unselect();
        } else {
            this.setSelected();
        }
    }

    isSelected() {
        return this.singleSelectType === singleSelectTypes.ACCOUNT;
    }

    setSelected() {
        this.setSingleSelectType({ type: singleSelectTypes.ACCOUNT });
        this.setPayingAmount();
        this.digitalPayPaymentErrorDisplayService.clearGlobalError();
    }

    unselect() {
        if (!this.isShowOnlyOnAccount && !this.hasListInstrumentsError) {
            this.setSingleSelectType({ type: singleSelectTypes.NONE });
            this.digitalPayPaymentDistributionService.removePayment(this.onAccountPaymentAmountKey);
        }
    }

    callOnPasswordFieldLoaded(value) {
        this.onPasswordFieldLoaded({ value });
        this.setDisableState(value);
    }

    setDisableState(shouldDisable) {
        if (shouldDisable) {
            this.digitalPayDisablePaymentStateService.addDisablePaymentState(ACCOUNT_PASSWORD_DISABLE_STATE_KEY, this.settings.digitalPayScreenReaderMessages.accountPasswordDisableStateMessage);
        } else {
            this.digitalPayDisablePaymentStateService.removeDisablePaymentState(ACCOUNT_PASSWORD_DISABLE_STATE_KEY);
        }
    }

    $onChanges(changes) {
        // Handle if On Account gets selected
        if (changes.singleSelectType) {
            const onAccountSelected = changes.singleSelectType.currentValue === singleSelectTypes.ACCOUNT;
            if (onAccountSelected) {
                this.setPayingAmount();
            } else if (changes.singleSelectType.previousValue === singleSelectTypes.ACCOUNT) {
                this.onPasswordReset();
            }
            this.callOnPasswordFieldLoaded(onAccountSelected ? this.isShowOnlyOnAccount || this.isEligibleForOnAccount : false);
        }

        // Handle if the Password field changes
        if (this.isSelected() && changes.accountPassword) {
            const password = changes.accountPassword.currentValue;
            this.setDisableState(!password || !password.length);
        }
    }
}

DigitalPayAccountController.$inject = ['Settings', 'DigitalPayPaymentDistributionService', 'DigitalPayPaymentErrorDisplayService', 'DigitalPayDisablePaymentStateService'];

const digitalPayAccountComponentDefinition = {
    controller: DigitalPayAccountController,
    template: require('./digital-pay-account.component.html').trim(),
    bindings: {
        singleSelectType: '<',
        setSingleSelectType: '&',
        onAccountPaymentAmountKey: '<',
        isShowOnlyOnAccount: '<',
        isEligibleForOnAccount: '<',
        onPasswordFieldLoaded: '&',
        accountPassword: '<',
        hasListInstrumentsError: '<',
        onPasswordReset: '&',
        shouldShowPayingAmount: '<',
    },
};

module.exports = {
    DigitalPayAccountController,
    digitalPayAccountComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/digitalpay/account/digital-pay-account.component.js